import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { US_STATES } from '../../shared/models/us-states';
import { ToastrService } from 'ngx-toastr';
import { InsureApiService } from '../../shared/services/insure-api.service';

@Component({
  selector: 'ins-get-quote',
  templateUrl: './get-quote.component.html',
})
export class GetQuoteComponent implements OnInit {
  quoteForm!: FormGroup;
  states = US_STATES;
  errorMessage = '';

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private insureApi: InsureApiService,
  ) {}

  ngOnInit(): void {
    this.quoteForm = this.fb.group({
      fullName: ['', Validators.required],
      phoneNumber: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      city: [''],
      state: [''],
      equipmentDescription: [''],
    });
  }

  onSubmit(): void {
    this.quoteForm.markAllAsTouched();
    if (this.quoteForm.invalid) {
      return;
    }

    const f = this.quoteForm.value;
    let body = 'Customer Information  <br>';
    body += '------------------------------------------------------- <br>';
    body += 'Customer Name: ' + f.fullName + '<br>';
    body += 'Phone Number: ' + f.phoneNumber + '<br>';
    body += 'E-mail: ' + f.email + '<br>';
    body += 'City: ' + (f.city || '') + '<br>';
    body += 'State: ' + (f.state || '') + '<br>';
    body += 'Equipment Description: ' + (f.equipmentDescription || '') + '<br>';

    this.insureApi
      .sendEmail({
        toAddresses: ['mmoragues@dfsinsure.com', 'jtaylor@dfsinsure.com'],
        subject: 'Quote has been requested from DFSInsure.com ',
        bodyHtml: body,
      })
      .subscribe({
        next: () => {
          this.toastr.success(
            'Thank you. We have received your quote request successfully. Your DFS Sales Manager will be in contact with you.',
          );
          this.quoteForm.reset();
        },
        error: () => {
          this.errorMessage =
            "Your request didn't go through. Please try again.";
        },
      });
  }
}
